export default __webpack_public_path__ + "static/media/about-header.fde586de.jpg";